<template>
    <div class="">
        <div class="mb-4 rounded border border-orange-300 bg-orange-100 p-4">
            <span class="font-semibold">Note:</span> Memberships are the same
            price regardless of provider level. Memberships only become active
            from the date that a student accepts your invite.
        </div>

        <table class="mb-4 table w-full">
            <thead>
            <tr>
                <th>Membership Length</th>
                <th class="!pr-6 !text-right">Price</th>
                <th class="!pl-6">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(membershipPlan, index) in membershipPlans">
                <tr>
                    <td>{{ membershipPlan.title }}</td>
                    <td class="text-right">
                        ${{ membershipPlan.price_usd }}&nbsp;USD
                    </td>
                    <td>
                        <div class="w-auto rounded border border-gray-450">
                            <div class="flex">
                                <input
                                    :tabindex="index + 1"
                                    class="flex w-12 flex-grow appearance-none items-center border-none px-4"
                                    type="text"
                                    step="1"
                                    min="0"
                                    @keydown="onlyAllowNumbers"
                                    v-model="
                                            form.membershipsInCart[index].qty
                                        "
                                />
                                <div
                                    class="flex w-8 flex-none flex-col text-center text-[15px] font-semibold"
                                >
                                    <div
                                        @click="
                                                incrementMembershipPlan(index)
                                            "
                                        class="flex h-1/2 items-center justify-center rounded-tr border-b border-gray-450 bg-gray-350 p-2 hover:cursor-pointer hover:bg-gray-350"
                                    >
                                        <svg
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5 0.916016V9.08268"
                                                stroke="#777777"
                                                stroke-width="1.16667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M0.914062 5H9.08073"
                                                stroke="#777777"
                                                stroke-width="1.16667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <div
                                        @click="
                                                decrementMembershipPlan(index)
                                            "
                                        class="flex h-1/2 h-1/2 items-center justify-center rounded-br bg-gray-350 p-2 hover:cursor-pointer hover:bg-gray-350"
                                    >
                                        <svg
                                            width="10"
                                            height="2"
                                            viewBox="0 0 10 2"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M0.914062 1H9.08073"
                                                stroke="#A6A6A6"
                                                stroke-width="1.16667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>

        <div class="flex flex-col gap-2">
            <div class="font-semibold">Payment</div>

            <div class="flex justify-between">
                <div class="">
                    Subtotal ({{ totalMembershipsInCart }}
                    memberships)
                </div>
                <div class="">{{ subtotal }} USD</div>
            </div>

            <div class="flex justify-between">
                <div class="">Taxes</div>
                <div class="">$0.00 USD</div>
            </div>
            <div class="flex justify-between">
                <div class="">
                    <div class="">Discount ({{ discountMessage }})</div>
                </div>
                <div class="">{{ discount }} USD</div>
            </div>
            <hr/>
            <div class="flex justify-between font-semibold">
                <div class="">Total</div>
                <div class="">{{ total }} USD</div>
            </div>
        </div>
        <GroupMembershipsDiscountNotice
            :next-discount-tier="nextDiscountTier"
        />
    </div>
</template>
<script>
import GroupMembershipsDiscountNotice from "@/Components/GroupMembershipsDiscountNotice";

export default {
    name: "GroupBuyMembershipsForm",
    components: {GroupMembershipsDiscountNotice},
    emits: ["cart-updated"],
    props: {
        existingMembershipsInCart: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            membershipPlans: this.$page.props.membershipPlans,
            form: this.$inertia.form({
                membershipsInCart: {},
            }),
            totalMembershipsInCart: 0,
            total: "$0.00",
            subtotal: "$0.00",
            discount: "$0.00",
            discountMessage: "No Discount",
            nextDiscountTier: {
                qty: 5,
                discountPercent: 10,
            },
        };
    },
    methods: {
        updateCart() {
            let vm = this;

            for (const [key, value] of Object.entries(
                this.form.membershipsInCart
            )) {
                this.form.membershipsInCart[key].qty = Number(value.qty);
            }


            axios
                .post(route("group.cart.update"), {
                    membershipsInCart: vm.form.membershipsInCart,
                })
                .then(function (response) {
                    vm.total = response.data.total;
                    vm.subtotal = response.data.subtotal;
                    vm.discount = response.data.discount;
                    vm.discountMessage = response.data.discountMessage;
                    vm.nextDiscountTier = response.data.nextDiscountTier;
                    vm.totalMembershipsInCart =
                        response.data.totalMembershipsInCart;

                    vm.$emit("cart-updated", {
                        total: vm.total,
                        membershipsInCart: vm.form.membershipsInCart,
                    });
                });
        },
        prepareMembershipsInCartArray() {
            let vm = this;

            vm.membershipPlans.forEach(function (plan, index) {
                let existingMembershipInCart = null;

                existingMembershipInCart = _.filter(
                    vm.existingMembershipsInCart,
                    function (cartItem) {
                        if (cartItem.planId === plan.id) {
                            return cartItem;
                        }
                    }
                );

                vm.form.membershipsInCart[index] = {
                    planId: plan.id,
                    qty: existingMembershipInCart.length
                        ? existingMembershipInCart[0].qty
                        : 0,
                };
            });
        },
        incrementMembershipPlan(index) {
            this.form.membershipsInCart[index].qty++;
        },
        decrementMembershipPlan(index) {
            if (this.form.membershipsInCart[index].qty > 0) {
                this.form.membershipsInCart[index].qty--;
            }
        },
        onlyAllowNumbers(event) {
            let keyCode = event.keyCode ? event.keyCode : event.which;
            if (
                (keyCode < 48 || keyCode > 57) &&
                (keyCode < 96 || keyCode > 105) &&
                keyCode !== 9 && // tab
                keyCode !== 8 && // delete
                keyCode !== 46 // backspace
            ) {
                event.preventDefault();
            }
        },
    },
    created() {
        this.prepareMembershipsInCartArray();
    },
    watch: {
        "form.membershipsInCart": {
            handler: _.debounce(function (val) {
                this.updateCart();
            }, 100),
            deep: true,
        },
    },
};
</script>
<style scoped lang="css">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}
</style>
